<template>
    <div>
        <div class="top-background-bloc w-100">
            <div class="pro-main-container-bloc pro-uska-link-container-bloc">
                <div class="flex-column container d-flex align-items-center justify-content-center">
                    <div>
                        <img src="/images/logo-vertical-uska-couleur.png" class="uska-logo">
                    </div>
                    <div>
                        <div class="flex-column">
                            <div class="uska-link-text d-flex justify-content-center">Gratuit</div>
                            <hr class="border-4">
                            <div class="uska-link-text d-flex justify-content-center mb-2">Mettez à jour vos
                                informations pour votre OT
                            </div>
                            <div class="uska-link-text d-flex justify-content-center mb-2">Analysez votre présence en
                                ligne
                            </div>
                            <div class="uska-link-text d-flex justify-content-center mb-4">Retrouvez vos
                                sollicitations
                            </div>
                            <div class="d-flex justify-content-center">
                                <a
                                  :href="uskaUrl" target="_blank"
                                >
                                    <v-btn class="uska-link-button w-fit">
                                        <span class="text-white">Créer mon compte gratuit</span>
                                    </v-btn>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProUskaLink",
    data() {
        return {
            uskaUrl: null,
            token: null,
        }
    },
    methods: {
        encodeUtmToHash(utmParams) {
            // Convertir l'objet en JSON
            let jsonString = JSON.stringify(utmParams)

            // Encoder en base64
            let base64 = btoa(unescape(encodeURIComponent(jsonString)));

            // Rendre le base64 URL-safe (remplacer +, /, = par des caractères sûrs)
            return base64
              .replace(/\+/g, "-")
              .replace(/\//g, "_")
              .replace(/=/g, "")
        },
    },
    async created() {
        this.token = this.$route.params.token

        let hash = this.encodeUtmToHash({
            utm_content: this.token,
            utm_source: 'hubo',
            utm_medium: 'email',
            utm_campaign: 'onboarding',
        })

        if (process.env.NODE_ENV === "production") {
            this.uskaUrl = "https://app.uska.fr/onboarding/freemium/" + hash
        } else if(process.env.NODE_ENV === "dev") {
            this.uskaUrl = "https://app.dev.uska.fr/onboarding/freemium/" + hash
        } else if(process.env.NODE_ENV === "qualif") {
            this.uskaUrl = "https://app.qualif.uska.fr/onboarding/freemium/" + hash
        } else if(process.env.NODE_ENV === "development") {
            this.uskaUrl = "https://app.preprod.uska.fr/onboarding/freemium/" + hash
        }
    },
}
</script>
